import React from 'react';
import { Grid } from '@material-ui/core';

import { IntlShape, injectIntl } from 'react-intl';
import messages from 'containers/AttributionManager/messages';
import { translate } from 'containers/services/translate';
import Dialog from 'containers/AttributionManager/Dialogs/index';
import {
  StyleDescriptionDialog,
  StyleTitleDialog,
} from 'containers/AttributionManager/styles';
export interface ConfirmationDialogProps {
  intl: IntlShape;
  confirmationDialog: boolean;
  handleCloseConfirmationDialog: any;
  handleValidate: any;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = (
  props,
): JSX.Element => {
  return (
    <Dialog
      open={props.confirmationDialog}
      onClose={props.handleCloseConfirmationDialog}
      validateDialog={props.handleValidate}
      content={
        <Grid container direction="column">
          <Grid item style={{ marginBottom: '30px' }}>
            <span style={StyleTitleDialog}>
              {translate(messages.confirmationDialogTitle, props)}
            </span>
          </Grid>
          <Grid item>
            <span style={StyleDescriptionDialog}>
              {translate(messages.confirmationDialogDescription, props)}
            </span>
          </Grid>
        </Grid>
      }
      title={''}
      disabled={false}
    />
  );
};

export default injectIntl(ConfirmationDialog);
